import { Asset } from '..';

export interface AssetReparentRequest {
    assetId: string;
    newParentId: string;
    newParentType: AssetParentType;
}

export interface AssetReparentResponse {
    asset?: Asset;
    success: boolean;
    message?: string;
}

export enum AssetParentType {
    Asset = 'asset',
    Site = 'site'
}